import TeamMemberList from "../members/TeamMemberList";
import ProjectList from "../projects/ProjectList";

export default function LeftSidebar() {
	return (
		<div className="sidebar">
			<ProjectList />
			<TeamMemberList />
		</div>
	);
}
